export default __webpack_public_path__ + "static/media/5325@3x.dd4d7045.png";